import { PageBreadcrumbs, PageNavigation } from '@client/toolkit';
import { PageLayout } from './page-layout';

export function PageListLayout({ breadcrumb, children }: { breadcrumb?: string; children: React.ReactNode }) {
  return (
    <PageLayout>
      {breadcrumb && (
        <PageNavigation>
          <PageBreadcrumbs>
            <PageBreadcrumbs.Link>{breadcrumb}</PageBreadcrumbs.Link>
          </PageBreadcrumbs>
        </PageNavigation>
      )}
      {children}
    </PageLayout>
  );
}
